import { render } from "./LoginAsAdminPage.vue?vue&type=template&id=6bc94ac1"
import script from "./LoginAsAdminPage.vue?vue&type=script&lang=js"
export * from "./LoginAsAdminPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__